// schemas/flowSchema.ts
import { z } from 'zod';

export const flowSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(3, 'Name must be at least 3 characters long'),
    status: z.enum(['published', 'draft', 'archived', 'hidden']).default('draft'),
    description: z.string().optional()
});
